<!-- <div class="d-flex justify-content-around flex-wrap flex-md-nowrap mt-5" *ngIf="theme$ | async as theme">
  <ng-container *ngIf="type$ | async as type">
    <div class="d-flex flex-column align-items-center seat-wrapper">
      <span class="seat seat-selected"></span>
      <span class="text-base text-center pt-1 color-label">
        {{ 'seats_selection.selected' | transloco }}
      </span>
    </div>
    <div class="d-flex flex-column align-items-center seat-wrapper">
      <span
        class="seat seat-taken"
        [ngStyle]="{
          backgroundColor: theme === 'dark' ? type.calculatedTakenColorDark : type.calculatedTakenColorLight
        }"
      ></span>
      <span class="text-base text-center pt-1 color-label">
        {{ 'seats_selection.taken' | transloco }}
      </span>
    </div>
    <div class="d-flex flex-column align-items-center seat-wrapper">
      <span class="seat" [ngStyle]="{ backgroundColor: theme === 'dark' ? type.colorDark : type.colorLight }"></span>
      <span class="text-base text-center pt-1 color-label">{{ type.name }}</span>
    </div>
  </ng-container>
</div>
 -->

<div class="d-flex justify-content-around flex-wrap flex-md-nowrap mt-5" *ngIf="theme$ | async as theme">
  <div class="d-flex flex-column align-items-center seat-wrapper">
    <span class="seat seat-selected">
      <ng-container *ngTemplateOutlet="personIcon"></ng-container>
    </span>
    <span class="text-base text-center pt-1 color-label">
      {{ 'seats_selection.selected' | transloco }}
    </span>
  </div>
  <div class="d-flex flex-column align-items-center seat-wrapper">
    <span
      class="seat seat-taken"
      *ngIf="configColors$ | async as configColors"
      [ngStyle]="{
        backgroundColor:
          theme === 'dark' ? configColors.calculatedTakenColorDark : configColors.calculatedTakenColorLight
      }"
    >
      <ng-container *ngTemplateOutlet="personIcon"></ng-container>
    </span>
    <span class="text-base text-center pt-1 color-label">
      {{ 'seats_selection.taken' | transloco }}
    </span>
  </div>
  <div class="d-flex flex-column align-items-center seat-wrapper" *ngFor="let type of types$ | async">
    <span class="seat" [ngStyle]="{ backgroundColor: theme === 'dark' ? type.colorDark : type.colorLight }"></span>
    <span class="text-base text-center pt-1 color-label">{{ type.name }}</span>
  </div>
</div>

<!-- Same marker the seat map injects onto occupied seats, so the legend matches what is drawn. -->
<ng-template #personIcon>
  <svg class="seat-person-icon" [attr.viewBox]="personIconViewBox" aria-hidden="true" focusable="false">
    <path [attr.d]="personIconPath"></path>
  </svg>
</ng-template>
